import { gql } from '@apollo/client';

export const DOMAIN_V2_BY_ID = gql`
  query DOMAIN_SERVICE_V2_getDomainById($id: ID!) {
    getDomainById(id: $id) {
      id
      name
      logo
      headerStyleId
      properties
      messages
    }
  }
`;

export const DOMAIN_V2_PRODUCT_LINES = gql`
  query DOMAIN_SERVICE_V2_getProductLines($inputFilter: InputFilterDTO!) {
    getProductLines(inputFilter: $inputFilter) {
      name
      rateSegment
      bcFormId
      rfqForms
      dependentOnProductLineId
      productLineId
      configurablePlans
      browsingConfigurablePlans
      policyAttributesFormId
      planAttributesBaseFormId
      planAttributesCustomFormId
      browsingType
      overrideRatesEligible
      dontProvideIneligible
      dynamicPortfolios {
        creationAvailable
        creationRoles
        carrierPortfolioSize
      }
      available
    }
  }
`;

export const DOMAIN_V2_BY_ID_FROM_COOKIES = gql`
  query DOMAIN_SERVICE_V2_getDomainByIdFromCookies {
    getDomainByIdFromCookies {
      id
      name
      properties
      dateDependent {
        config
        effectiveDate {
          from
          to
        }
        productLines {
          name
          rateSegment
          productLineId
        }
      }
    }
  }
`;

export const DOMAIN_V2_CONFIG_BY_DATE = gql`
  query DOMAIN_SERVICE_V2_getConfigByEffectiveDate($id: ID!, $effectiveDate: String) {
    getConfigByEffectiveDate(id: $id, effectiveDate: $effectiveDate)
  }
`;

export const DOMAIN_V2_PRODUCT_LINES_BY_EFFECTIVE_DATE_AND_STATE = gql`
  query DOMAIN_SERVICE_V2_getProductLinesByEffectiveDateAndState($id: ID!, $effectiveDate: String!, $state: String!) {
    getProductLinesByEffectiveDateAndState(id: $id, effectiveDate: $effectiveDate, state: $state) {
      name
      rateSegment
      productLineId
    }
  }
`;

export const GET_ALL_DOMAINS = gql`
  query DOMAIN_SERVICE_V2_getAllDomains {
    getAllDomains {
      id
      name
      headerStyleId
    }
  }
`;
